module.exports = {"TXTMOB_See_All":{"id":"TXTMOB_See_All","defaultMessage":"Vezi tot"}}